import React from 'react';
import { motion } from 'framer-motion';
import { CertificationBadge } from './CertificationBadge';
import { Award, Factory, Globe2, ShieldCheck, TrendingDown, Settings } from 'lucide-react';
export function WhyChooseUs() {
  const features = [{
    icon: Award,
    title: 'Premium Quality',
    description: '100% raw Vietnamese human hair, unprocessed, cuticle aligned, and double drawn options.'
  }, {
    icon: Factory,
    title: 'Factory Direct',
    description: 'Purchase directly from our manufacturing facility. No middlemen, maximizing your profit margins.'
  }, {
    icon: Globe2,
    title: 'Global Shipping',
    description: 'Fast and reliable shipping to USA, Europe, Nigeria, and worldwide via DHL/FedEx/UPS.'
  }, {
    icon: ShieldCheck,
    title: 'Quality Control',
    description: 'Strict 3-step inspection process for every bundle before shipping to ensure consistency.'
  }, {
    icon: TrendingDown,
    title: 'Competitive Pricing',
    description: 'Tiered wholesale pricing structure designed to support businesses of all sizes.'
  }, {
    icon: Settings,
    title: 'Custom Orders',
    description: 'We customize textures, colors, and packaging to help build your own brand identity.'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-330">
      {/* Real Factory Background - Minimal Overlay for Authenticity */}
      <div className="absolute inset-0 z-0" data-id="element-331">
        <img src="https://cdn.magicpatterns.com/uploads/mZP3d81ZxTpPc3V8qLeXao/Add_a_heading.png" alt="Lux Hair Factory Manufacturing Floor" className="w-full h-full object-cover" data-id="element-332" />
        {/* Very light overlay for text readability only */}
        <div className="absolute inset-0 bg-white/75" data-id="element-333" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-334">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-335">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-336">
            <h2 className="text-[#d4af37] font-semibold tracking-[0.2em] uppercase text-sm mb-6" data-id="element-337">
              WHY CHOOSE LUX HAIR VIETNAM
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4B280B] mb-6 leading-tight" data-id="element-338">
              Your Trusted Manufacturing Partner
            </h3>
            <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-339">
              We don't just sell hair; we build long-term partnerships with
              salon owners and distributors through consistency and trust.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-340">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-341">
              <CertificationBadge icon={feature.icon} title={feature.title} description={feature.description} data-id="element-342" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}